module.exports = __webpack_public_path__ + "static/media/tiger.a44a1ee3.png";